import actionCreatorFactory from "typescript-fsa";

import { normalizeActions } from "@ea/shared_components/redux/common.actions";
import {
  createDataModuleActions,
  createTableActionsGetter,
} from "@ea/shared_components/redux/common.data.actions";
import { Guard } from "@ea/shared_types/types";

const actionCreator = actionCreatorFactory("GUARD_MODULE");

export const moduleActions = createDataModuleActions<Guard>(actionCreator);
export const getGuardsTableActions = createTableActionsGetter(
  normalizeActions(moduleActions.table),
);
export const guardActions = {
  ...normalizeActions(moduleActions.data),
};
export const guardsActionCreators = {
  ...moduleActions,
};
